import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {
    CardBody,
    Col,
    Form, Input,
    Modal,
    ModalBody,
    ModalHeader,
    Row
} from 'reactstrap';


import {ButtonCancel, ButtonOk, CustomButton} from "../buttons/buttonsActions";
import MapController from "./MapController";
import {TT_EDIT} from "../i18n/toolTips";
import {GenericButton} from "../buttons/customButtons";


export const MapPickerModal = forwardRef((props, ref) => {

    const [modal, setModal] = useState(false);
    const [initialPosition] = useState(props.initialPosition !== undefined ? props.initialPosition : {
        lat: 20.580, lng: -87.119
    });
    // const [udn] = useState( JSON.parse(localStorage.getItem('selectedUdn')) || props.udn);
    const [marker, setMarker] = useState(props.marker !== undefined ? props.marker : initialPosition);
    const [markers, setMarkers] = useState([]);
    // const [googleConfig, setGoogleConfig] = useState(props.googleConfig || null);
    const [ googleConfig, setGoogleConfig ] = useState(props.googleConfig || null);
    const [updateMarkerPosition] = useState(props.updateMarkerPosition !== undefined ? props.updateMarkerPosition : false);
    const [pointA, setPointA] = useState( null );
    const [lat, setLat] = useState( initialPosition.lat );
    const [lng, setLng] = useState( initialPosition.lng );

    useEffect(() => {
        setInitialPosition();
    }, []);

    const setInitialPosition = () => {
        if (props.initialPosition !== undefined) {
            let iposition = {
                title: props.googleConfig?.marker?.title !== undefined ? props.googleConfig?.marker?.title : "",
                name: props.googleConfig?.marker?.name !== undefined ? props.googleConfig?.marker?.name : "",
                position: initialPosition
            }
            setMarkers([iposition]);
            setMarker(initialPosition);
        }
    }

    useEffect(() => {
        navigator.geolocation.getCurrentPosition((navigatorPosition) => {
            // console.log( 'lat:' +  navigatorPosition.coords.latitude,  'lng:' + navigatorPosition.coords.longitude)
            setPointA({
                lat : parseFloat(navigatorPosition.coords.latitude) ,
                lng : parseFloat(navigatorPosition.coords.longitude),
            });
        })
    }, [ ]);

    const showModal = () => {
        setModal(!modal);
    }

    const returnAccept = () => {
        props.setPosition(marker);
        showModal();
    }

    const onMapClick = (markerP) => {
        setMarker(markerP.position);
        setGoogleConfig({mapOptions: {...googleConfig, center: markerP.position}});
    }

    const onCenterMe = () => {
        if (pointA !== null) {
            setMarker(pointA);
            setLat(pointA.lat);
            setLng(pointA.lng);
            setGoogleConfig({mapOptions: {...googleConfig, center: pointA}});
            props.setPosition(pointA);
            setModal(!modal);
        }
    }

    useImperativeHandle(ref, () => ({
        showModal(_googleConfig) {
            setInitialPosition();
            setGoogleConfig(_googleConfig);
            setModal(!modal);
        }
    }));

    //let lat = marker !== undefined ? marker?.lat : initialPosition.lat;
    //let lng = marker !== undefined ? marker?.lng : initialPosition.lng;
    return (
        <Modal
            isOpen={modal}
            toggle={showModal}
        >
            <ModalHeader toggle={showModal}>Seleccionar ubicación</ModalHeader>
            <ModalBody>
                <Form>
                    <Row>
                        <Col md="12">
                            <GenericButton
                                style={'table'}
                                toolTip={TT_EDIT}
                                label={'Centra en mi ubicación'}
                                icon={'fa-pen'}
                                permission={'edit'}
                                onClick={onCenterMe}
                            />
                        </Col>
                    </Row>
                    <Row className={"mapGoogleContainer"}>
                        <Col md="12">
                            {
                                googleConfig?.mapOptions !== undefined &&
                                <MapController mode={'POINT_SELECT'}
                                               onMapClick={onMapClick}
                                               googleMapConfig={googleConfig}
                                               markers={markers}
                                               pointA={pointA}
                                               updateMarkerPosition={updateMarkerPosition}/>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <Input type="text" disabled value={lat + ', ' + lng}/>
                        </Col>
                    </Row>
                    <CardBody>
                        <div className="float-right">

                            <ButtonOk onClick={() => {
                                returnAccept()
                            }}/>
                            <ButtonCancel onClick={() => {
                                showModal()
                            }}/>
                        </div>
                    </CardBody>
                </Form>
            </ModalBody>
        </Modal>
    )
})